module.exports = __webpack_public_path__ + "static/media/kasu.c81caf50.png";